import { Injectable } from '@angular/core';
import { FeatureFlag, requireFeatureEnabled } from '../feature-flags';
import { firstValueFrom } from 'rxjs';
import { UsersService } from '@platform/api-client';
import type {
  UserIssuanceV3CmdBody,
  UserIssuanceV3Response
} from '@platform/api-client';

type UserIssuanceRequest = UserIssuanceV3CmdBody;
type UserIssuanceResponse = UserIssuanceV3Response;

/**
 * Driver Session Issuance Service
 *
 * Thin API wrapper for requesting a signed Driver Session issuance from the
 * backend.
 */
@Injectable({
  providedIn: 'root'
})
export class DriverSessionIssuanceService {
  constructor(
    private usersService: UsersService
  ) {}

  /**
   * Request new issuance from api
   */
  async fetchIssuance(publicKey: string): Promise<UserIssuanceResponse> {
    requireFeatureEnabled(FeatureFlag.DriverSession);
    const request: UserIssuanceRequest = {
      publicKey
    };

    return firstValueFrom(
      this.usersService.apiV3UserIssuancePost(request)
    );
  }
}
